import React from 'react';
import Button from '../Button';

interface ErrorModalProps {
  message: React.ReactNode;
  onClose: () => void;
  buttonCustom?: String;
  className?: String;
}

const AlertModal: React.FC<ErrorModalProps> = ({ message, onClose, buttonCustom = 'Chiudi', className = '' }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div className={`bg-white p-6 rounded-3xl shadow-lg max-w-md w-full ${className}`}>
        <div className="mb-4 text-center">{message}</div>
        <div className="flex justify-center">
          <Button
            onClick={onClose}
            variant="blue"
            className='px-4 py-2'
          >
            {buttonCustom}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AlertModal;
